import { Component, inject, input, output } from "@angular/core";
import { UsersService } from "@kno2/data-access/users";
import { ConfirmationDialogService } from "@kno2/shared/confirmation-dialog";
import { noop } from "@kno2/utils";

@Component({
    selector: "kno2-profile-authorized-applications",
    imports: [],
    templateUrl: "./profile-authorized-applications.component.html"
})
export class ProfileAuthorizedApplicationsComponent {
    private readonly confirmationDialogService = inject(ConfirmationDialogService);
    private readonly usersService = inject(UsersService);

    public userId = input.required<string>();
    public authorizedApps = input([]);
    public onRemoveApp = output<void>();

    public async removeApplication(appId: string): Promise<void> {
        const { result } = await this.confirmationDialogService.open({
            bodyText: "Are you sure you want to remove this application?",
            okText: "Remove"
        });

        if (!result) return;

        try {
            await this.usersService.removeApplication(this.userId(), appId);
            this.onRemoveApp.emit();
        } catch {
            noop();
        }
    }
}
